/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

$(document).ready(function () {
  /****************************************************************** */
  if ($(window).width() < 600) {
    $(".extentionText").hide();
    $(".show_hide").on("click", function () {
      var txt = $(".extentionText").is(':visible') ? '...Weiterlesen' : '...Lese weniger';
      $(".show_hide").text(txt);
      $(this).prev('.extentionText').slideToggle(200);
    });
  } else {
    $(".show_hide").hide();
  }
  /******************************************************************* */


  var swatchButton = document.querySelector('.swatch__button');
  $(document).on('change', '.swatch__button > input', function (e) {
    _colorChanged(e);
  });

  function _colorChanged(event) {
    // We need to change the URL of the various links
    target = event;
    var productItem = target.closest('.product-item'),
        variantUrl = target.getAttribute('data-variant-url');
    var productColorName = target.closest('.customizeswatch').querySelector('label.ColorSwatch--small').getAttribute('title');
    productItem.querySelector('.variant-color').innerHTML = productColorName;
    productItem.querySelector('.product-link-image').setAttribute('href', variantUrl);
    productItem.querySelector('.product-information > a').setAttribute('href', variantUrl); // If we have a custom image for the variant, we change it

    var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    var originalImageElementSource = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate) > picture > source');
    var replaceImageElement = productItem.querySelector('.product-item__bg__under');

    if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
      var newImageElement = document.createElement('source');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImageElement.setAttribute('data-aos', target.getAttribute('data-aos'));
      newImageElement.setAttribute('data-aos-delay', target.getAttribute('data-aos-delay'));
      newImageElement.setAttribute('data-aos-duration', target.getAttribute('data-aos-duration'));
      newImageElement.setAttribute('data-aos-anchor', target.getAttribute('data-aos-anchor'));
      newImageElement.setAttribute('data-aos-easing', 'ease-out-quart');
      newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
      newImageElement.setAttribute('data-bgset', target.getAttribute('data-bgset'));
      replaceImageElement.setAttribute('data-bgset', target.getAttribute('data-bgset'));
      replaceImageElement.setAttribute('class', 'product-item__bg__under Image--fadeIn ProductItem__Image lazyloading'); // Replace the original node
      // if (window.theme.productImageSize === 'natural') {
      //   originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
      // }
      //originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));

      originalImageElementSource.replaceWith(newImageElement);
    }
  }
});
/*$(document).ready(function () {

    if (window.location.href.indexOf("sort_by") == -1 || window.location.href.indexOf("sort_by=no") > 0) {
      shuffleProductVariant($(".product-grid"));
    }
  
    //the fisher yates algorithm, from http://stackoverflow.com/questions/2450954/how-to-randomize-a-javascript-array
    function shuffleProductVariant(items) {
  
      items.each(function () {
        var divs = $(this).find('div.product-item');
        for (var i = 0; i < divs.length; i++) $(divs[i]).remove();
  
        var i = divs.length;
        if (i == 0) return false;
        while (--i) {
          var j = Math.floor(Math.random() * (i + 1));
          var tempi = divs[i];
          var tempj = divs[j];
          divs[i] = tempj;
          divs[j] = tempi;
        }
        
        for (var i = 0; i < divs.length; i++) $(divs[i]).appendTo(this);
      });
    }

  var swatchButton = document.querySelector('.swatch__button');

  $(document).on('change', '.swatch__button > input', function (e) {
    _colorChanged(e);
  });

  function _colorChanged(event) {
    // We need to change the URL of the various links
    target = event;

    var productItem = target.closest('.product-item'),
        variantUrl = target.getAttribute('data-variant-url');
      
     var productColorName =  target.closest('.customizeswatch').querySelector('label.ColorSwatch--small').getAttribute('title');
     productItem.querySelector('.variant-color').innerHTML = productColorName;

    productItem.querySelector('.product-link-image').setAttribute('href', variantUrl);
    productItem.querySelector('.product-information > a').setAttribute('href', variantUrl);

    // If we have a custom image for the variant, we change it
    var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    var originalImageElementSource = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate) > picture > source');
    var replaceImageElement = productItem.querySelector('.product-item__bg__under');

    if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
      var newImageElement = document.createElement('source');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImageElement.setAttribute('data-aos', target.getAttribute('data-aos'));
      newImageElement.setAttribute('data-aos-delay', target.getAttribute('data-aos-delay'));
      newImageElement.setAttribute('data-aos-duration', target.getAttribute('data-aos-duration'));
      newImageElement.setAttribute('data-aos-anchor', target.getAttribute('data-aos-anchor'));
      newImageElement.setAttribute('data-aos-easing', 'ease-out-quart');
      newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
      newImageElement.setAttribute('data-bgset', target.getAttribute('data-bgset'));

      replaceImageElement.setAttribute('data-bgset', target.getAttribute('data-bgset'));
      replaceImageElement.setAttribute('class', 'product-item__bg__under Image--fadeIn ProductItem__Image lazyloading');

      // Replace the original node
      // if (window.theme.productImageSize === 'natural') {
      //   originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
      // }

      //originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
      originalImageElementSource.replaceWith(newImageElement);
    }
  }

  }); // end ready02 */

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkvio_yoga"] = self["webpackChunkvio_yoga"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;